import { z } from '@bonanza-social/toolkit/api';

export const GameplaySchema = z.object({
  url: z.string(),
  provider: z.string(),
});
